import type { WorkspaceLoginResponse } from "./types";

export async function exchangeWorkspaceGoogle(
  baseUrl: string,
  code: string,
  state: string,
): Promise<WorkspaceLoginResponse> {
  const response = await fetch(`${baseUrl}/api/auth/google/exchange`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: JSON.stringify({
      code,
      state,
      redirect_uri: `${window.location.origin}/oauth/callback`,
    }),
  });
  const data = (await response.json()) as WorkspaceLoginResponse;
  if (!response.ok || data.error || !data.token || !data.user) {
    return {
      error: data.error ?? "google_workspace_exchange_failed",
    };
  }
  return data;
}
